import {InjectionToken} from '@angular/core';

export interface ApiOptions {
  svgIconSetPath?: string;
  loginRedirect?: string;
  logoutRedirect?: string;
}

export const ApiOptionsToken = new InjectionToken<ApiOptions>('api.options');
